// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pz-c";
export var backButton = "_pz-4";
export var backIcon = "_pz-5";
export var chevronShortcut = "_pz-6";
export var container = "_pz-1";
export var editor = "_pz-8";
export var editorWrapper = "_pz-7";
export var prefix = "_pz-2";
export var searchIcon = "_pz-3";
export var suffix = "_pz-9";
export var suffixContent = "_pz-a";
export var suffixText = "_pz-b";
export var wrapper = "_pz-0";